"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectPointers = exports.detectPointersInner = void 0;
const num_1 = require("../law/num");
const std = __importStar(require("../law/std"));
const sentenceEnv_1 = require("../node/container/sentenceEnv");
const controls_1 = require("../node/el/controls");
const env_1 = require("../parser/cst/env");
const _sentenceChildren_1 = __importStar(require("../parser/cst/rules/$sentenceChildren"));
const _pointerRanges_1 = require("./textParser/rules/$pointerRanges");
const detectPointersInner = (options) => {
    const { elToBeModified, appdxPointers, stopChars } = options;
    const errorMessages = [];
    if (std.isStdEL(elToBeModified, ["LawTitle", "LawNum", "QuoteStruct", "ArticleTitle", ...std.articleGroupTitleTags, ...std.paragraphItemTitleTags, ...std.appdxItemTitleTags, ...std.supplProvisionAppdxItemTitleTags])) {
        //
    }
    else if (elToBeModified instanceof controls_1.__Parentheses && elToBeModified.attr.type === "square") {
        //
    }
    else if ((0, sentenceEnv_1.isSentenceLike)(elToBeModified) && elToBeModified.children.length > 0) {
        const target = elToBeModified.innerXML();
        const result = _sentenceChildren_1.default.match(0, target, (0, env_1.initialEnv)({
            options: {
                reParenthesesInlineTextChars: (0, _sentenceChildren_1.makeReParenthesesInlineTextChars)(stopChars),
                reOutsideParenthesesTextChars: (0, _sentenceChildren_1.makeReOutsideParenthesesTextChars)(stopChars),
                rePeriodSentenceTextChars: (0, _sentenceChildren_1.makeRePeriodSentenceTextChars)(stopChars),
                inlineTokenRule: _pointerRanges_1.$inlineWithPointerRanges,
                appdxPointers,
            },
            baseOffset: elToBeModified.children[0].range?.[0],
        }));
        if (result.ok && result.nextOffset === target.length) {
            elToBeModified.children.splice(0, elToBeModified.children.length, ...result.value.value);
            errorMessages.push(...result.value.errors);
        }
        else {
            const message = `detectPointersInner: Error: ${elToBeModified.innerXML()}`;
            throw new Error(message);
        }
    }
    else {
        for (const c of elToBeModified.children) {
            if (typeof c === "string")
                continue;
            errorMessages.push(...(0, exports.detectPointersInner)({ elToBeModified: c, appdxPointers, stopChars }));
        }
    }
    return errorMessages;
};
exports.detectPointersInner = detectPointersInner;
const detectPointers = (elToBeModified) => {
    const appdxItems = (std.isLaw(elToBeModified)
        ? elToBeModified.children.find(std.isLawBody)?.children.filter(std.isAppdxItem) ?? []
        : std.isLawBody(elToBeModified)
            ? elToBeModified.children.filter(std.isAppdxItem)
            : []);
    const supplProvisionAppdxItems = (std.isLaw(elToBeModified)
        ? elToBeModified.children.find(std.isLawBody)?.children.find(c => std.isSupplProvision(c) && !c.attr.AmendLawNum)?.children.filter(std.isSupplProvisionAppdxItem) ?? []
        : std.isLawBody(elToBeModified)
            ? elToBeModified.children.find(c => std.isSupplProvision(c) && !c.attr.AmendLawNum)?.children.filter(std.isSupplProvisionAppdxItem) ?? []
            : std.isSupplProvision(elToBeModified) && !elToBeModified.attr.AmendLawNum
                ? elToBeModified.children.filter(std.isSupplProvisionAppdxItem)
                : []);
    const appdxPointers = [];
    const stopChars = new Set(_pointerRanges_1.pointerRangesCandidateChars);
    for (const el of [...appdxItems, ...supplProvisionAppdxItems]) {
        const origName = el.children.find(c => std.isAppdxItemTitle(c) || std.isSupplProvisionAppdxItemTitle(c))?.text();
        if (!origName)
            continue;
        const digitsName = origName
            ?.replace(/(?<=[^(（])(?:[(（](?![0123456789０１２３４５６７８９〇一二三四五六七八九十百千]+[)）])[^)）]+[)）])+$/g, "")
            .split(/\s+/g)[0]
            .replace(/^[(（]([^)）]+)[)）]$/, m => m[1]);
        appdxPointers.push({
            pointerText: digitsName,
            el,
        });
        stopChars.add(digitsName[0]);
        const kanjiNumName = digitsName
            ?.replace(/[0123456789０１２３４５６７８９]+/g, num_1.digitsToKanjiNum);
        if (digitsName !== kanjiNumName) {
            appdxPointers.push({
                pointerText: kanjiNumName,
                el,
            });
            stopChars.add(kanjiNumName[0]);
        }
        appdxPointers.sort((a, b) => b.pointerText.length - a.pointerText.length);
    }
    const errors = (0, exports.detectPointersInner)({ elToBeModified, appdxPointers, stopChars: [...stopChars].join("") });
    return { value: appdxPointers, errors };
};
exports.detectPointers = detectPointers;
exports.default = exports.detectPointers;
//# sourceMappingURL=detectPointers.js.map